<template>
	<section class="d-flex w-100">

		<div class="d-flex flex-column" id="neworders">

			<div class="row header-emotivi mb-3 justify-content-around align-items-end">
				<div class="col">
					<h1>Commandes</h1>
				</div>
			</div>

			<div class="flex-grow-1 overflow-hidden d-flex">

				<div class="card card-no-margin">

					<h4>{{ orders_total }} nouvelles commandes</h4>

					<div class="d-flex justify-content-end align-items-start mb-3" style="margin-top: -60px">
						<m-form-select
							:width="300"
							label="Filter par statut"
							label-position="top"
							:name="$Utils.randomstring('filterStatus')"
							v-model="filterStatus"
							:items="$store.state.items_no_statuses"
							@input="loadOrders"
						/>
						<m-form-text
							class="ml-3"
							label="Rechercher"
							label-position="top"
							v-model="filterText"
							name="search"
							autocomplete
							@input="loadOrders"
						/>
					</div>


					<m-list
						ref="orderslist"
						:dynamic="true"
						:items="orders"
						item-value="or_id"
						:item-height="30"
						:limit="orders_limit"
						:skip="orders_skip"
						:total="orders_total"
						:bgstrip="true"
						@changerange="ordersChangeRange"
						@itemclick="editOrder"
					>
						<template v-slot:ths="{}">
							<th style="width: 40px">
								#
							</th>
							<th>
								<span class="pointer">Contact</span>
							</th>
							<th>
								<span class="pointer">Bénéficiaire</span>
							</th>
							<th>
								<span class="pointer">Statut</span>
							</th>
							<th>
								<span class="pointer">Mis à jour le</span>
							</th>
							<th>
								<span class="pointer">Créée le</span>
							</th>
						</template>
						<template v-slot:tds="{ item }">
							<td :style="`width: 40px; background-color: ${isLate(item.no_status_date)};`">
								<span class="position-relative">
									{{ item.no_id }}
									<div v-show="isNew(item.no_status)" class="label-new"></div>
								</span>
							</td>
							<td>
								{{ item.co_id.co_invoice_firstname }} {{ item.co_id.co_invoice_name }}
							</td>
							<td>
								{{ item.en_id ? item.en_id.en_fullname : "---" }}
							</td>
							<td>
								{{ getOrderStatus(item.no_status) }}
							</td>
							<td >
								{{ $moment(item.no_status_date).format("DD/MM/YYYY HH[H]mm") }}
							</td>
							<td >
								{{ $moment(item.createdAt).format("DD/MM/YYYY HH[H]mm") }}
							</td>
						</template>
					</m-list>
						
					<neworder-win-edit :row_no_p="itemSelected" v-model="dialog" @reload="loadOrders" />

				</div>

			</div>
		</div>
	</section>
</template>

<script>
export default {
  name: "neworders",
  components: { },
  data() {
    return {

      orders: [],
      orders_total: 0,
      orders_limit: 50,
      orders_skip: 0,
      sortOrder: "asc",
      sortFields: [],
      row_en: {},
      filterText: "",
      filterStatus: "",
      itemSelected: {},
      dialog: false,
    };
  },

  watch: {

  },

  async mounted() {

    let id = parseInt(this.$route.params.no_id);

    if (id) {
      this.itemSelected.no_id = id;
      this.dialog = true;
    }

    this.loadOrders();

  },
  computed: {},
  methods: {

	isNew(status) {
		return status === "PAYMENT_PENDING" || status === "PAYMENT_DONE";
	},

	isLate(updatedAt) {

		const daysNb = this.$moment(updatedAt).diff(new Date(), 'days');

		let color;

		switch(daysNb) {
			case 7:
				color = "#e5e2b5";
				break;
			case 10:
				color = "#d9a2a2";
				break;
			default:
				color = "transparent";
				break;
		}

		return color;
	},

	getOrderStatus(value) {
		const result = this.$store.state.items_no_statuses.find(status => status.value === value);
		return result ? result.text : "???";
	},

    ordersChangeRange(skip) {
      this.orders_skip = skip;
      this.loadOrders();
    },

    sortItems(fields) {
      if (fields.length && this.sortFields.length && fields[0] == this.sortFields[0]) {
        this.sortOrder = this.sortOrder == "asc" ? "desc" : "asc";
      }
      this.sortFields = fields;
      this.loadOrders();
    },

    async loadOrders() {

		let params = {
			skip: this.orders_skip,
			limit: this.orders_limit
		};

		if(this.filterText){
			params.search = this.filterText;
		}

		if(this.filterStatus){
			params.status = this.filterStatus;
		}

		this.cancelAxiosLoadOrders && this.cancelAxiosLoadOrders();

		let response = await this.$axios.get(`${this.$config.server_url}/extranet/2.0/newOrder/list`, {
			params,
			cancelToken: new this.$axios.CancelToken(c => {
				this.cancelAxiosLoadOrders = c;
			})
		});

		if(!response || !response.data){
			return;
		}

		this.orders = response.data.data;
		this.orders_total = response.data.meta.total;
    },

    editOrder(item) {
      this.itemSelected = item;
      this.dialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/styles.scss";

.label-new {
	position: absolute;
	right: -6px;
	top: 0px;
	width: 6px;
	height: 6px;
	background-color: #f00;
	border-radius: 3px;
}
</style>
